import { Link, Outlet } from "react-router";
import { ProfileMenu } from "../../components/layout/components/header/ProfileMenu.tsx";
import Logo from "/images/logo_dark.svg";

export const CompanyRouteLayout = () => {
  return (
    <div className="h-dvh flex flex-col">
      <header className="py-4 flex items-center justify-between px-6 bg-monochrome-900 border-b border-monochrome-200">
        <Link to="/">
          <img src={Logo} alt="Company Logo" className="h-[35px] w-auto" />
        </Link>
        <ProfileMenu />
      </header>
      <div className="py-4 px-4 lg:px-6 scroll-vertical overflow-y-auto bg-primary-25 h-full">
        <div className="max-w-350 m-auto h-full">
          <Outlet />
        </div>
      </div>
    </div>
  );
};
